import { type ChangeEvent, type FormEvent } from 'react'

import { Field } from '#app/components/form/field.tsx'
import { SelectField } from '#app/components/form/select-field.tsx'

import {
	REPOSITORY_COPY,
	REPOSITORY_SYSTEM_OPTIONS,
} from '#app/routes/mocra+/_form+/components/repositories/constants.ts'
import { type RepositoryDraft } from '#app/routes/mocra+/_form+/components/repositories/types.ts'

type DraftErrors = Partial<Record<keyof RepositoryDraft, string>>

type Props = {
	readonly formId: string
	readonly draft: RepositoryDraft
	readonly errors: DraftErrors
	readonly onDraftFieldChange: <Field extends keyof RepositoryDraft>(
		field: Field,
		value: RepositoryDraft[Field],
	) => void
	readonly onSubmit: (event: FormEvent<HTMLFormElement>) => void
}

export function RepositoryForm({
	formId,
	draft,
	errors,
	onDraftFieldChange,
	onSubmit,
}: Props) {
	const handleSystemChange = (event: ChangeEvent<HTMLSelectElement>) => {
		onDraftFieldChange(
			'system',
			event.target.value as RepositoryDraft['system'],
		)
	}

	const handleLocationChange = (event: ChangeEvent<HTMLInputElement>) => {
		onDraftFieldChange('location', event.target.value)
	}

	return (
		<form id={formId} onSubmit={onSubmit}>
			<SelectField
				labelProps={{ children: REPOSITORY_COPY.fields.systemLabel }}
				selectProps={{
					value: draft.system,
					onChange: handleSystemChange,
				}}
				options={REPOSITORY_SYSTEM_OPTIONS}
			/>
			<Field
				labelProps={{ children: REPOSITORY_COPY.fields.locationLabel }}
				inputProps={{
					value: draft.location,
					onChange: handleLocationChange,
					type: 'text',
				}}
				errors={errors.location ? [errors.location] : undefined}
			/>
		</form>
	)
}
